/**
*
* RedCalendar
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import formatDate from 'helpers/formatDate';
import setLanguageContent from 'helpers/setLanguageContent';


import getCalendar from 'components/Templates/general/getCalendar';

import Wrapper from 'components/Templates/dynamics/Wrapper';
import TemplateFilterSwitch from 'components/TemplateFilterSwitch';
import TagText from 'components/Tag/styles/TagText';

import {
  sortByDate
} from './helpers';


import CalendarsPlaceholder from './styles/CalendarsPlaceholder';

import defaultTextValues from './defaultTextValues';
import eventBackgroundFallback from 'components/Templates/styles/Red/assets/JPG/venue.jpg'


class RedCalendar extends React.Component {
  constructor(props) {
    super();

    this._isMounted = false;

    const {
      commonData,
      calendars
    } = props;

    const {
      componentPayload
    } = commonData;

    const {
      calendarId,
    } = componentPayload;

    this.setSelectedFilter = this.setSelectedFilter.bind(this);


    const getCurrentCalendar = getCalendar(calendarId, calendars);

    this.state = {
      selectedLocationFilter: [],
      selectedTagsFilter: [],
      ...getCurrentCalendar,
    };

  }



  setSelectedFilter(filter, type) {
    const newFilters = this.state[`selected${type}Filter`];
    if (newFilters.includes(filter)) {
      const index = newFilters.indexOf(filter);
      newFilters.splice(index, 1);
      return this.setState({
        [`selected${type}Filter`]: newFilters
      });
    }

    newFilters.push(filter);
    return this.setState({
      [`selected${type}Filter`]: newFilters
    });


  }


  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate(prevProp) {
    const {
      commonData,
      calendars
    } = this.props;

    const {
      componentPayload
    } = commonData;

    const {
      calendarId
    } = componentPayload;

    if (prevProp.commonData.componentPayload.calendarId !== calendarId) {

      const getCurrentCalendar = getCalendar(calendarId, calendars);

      const newState = {
        ...getCurrentCalendar
      };

      this.setState(newState);
    }
  }



  render() {
    const {
      commonData,
      openEditor,
      commonProps,
      language
    } = this.props;

    const {
      isEditor,
      componentPayload,
      customStyles,
      styling
    } = commonData;

    const {
      enableFilters,
      availableTags
    } = componentPayload;

    const {
      calendarsList,
      selectedLocationFilter,
      selectedTagsFilter,
    } = this.state;

    const includeOnline = enableFilters && calendarsList?.data?.events?.find(event => event.isOnline);
    const availableLocations = enableFilters && includeOnline ? [...calendarsList?.data?.uniqueCities || [], 'Online'] : calendarsList?.data?.uniqueCities || [];

    const thisCalendarTags = enableFilters && availableTags ? availableTags.filter(tag => calendarsList?.data?.availableTags?.includes(tag.tagId)) : '';

    const selectedFilters = {
      Location: selectedLocationFilter.length ? selectedLocationFilter : [],
      Tags: selectedTagsFilter.length ? selectedTagsFilter : []
    };

    const availableFilters = {
      Location: availableLocations,
      Tags: thisCalendarTags
    };


    const activeFiltersNumber = enableFilters && Object.keys(selectedFilters).reduce((acc, key) => acc + selectedFilters[key].length, 0);
    const filteredCalendars = (selectedLocationFilter.length || selectedTagsFilter.length) && calendarsList && calendarsList.data && calendarsList.data.events ? calendarsList.data.events.sort(sortByDate).filter(calendar => {


      let isFiltered = false;

      for (const filterKey in selectedFilters) {

        if (selectedFilters[filterKey].length) {

          const lowercaseKey = filterKey.toLowerCase();
          if (Array.isArray(calendar[lowercaseKey])) {
            const intersection = calendar[lowercaseKey].filter(value => selectedFilters[filterKey].includes(value));
            if (!intersection.length) {
              isFiltered = false;
              break;
            }
            isFiltered = true;
          }




          if (typeof calendar[lowercaseKey] === 'string' || filterKey === 'Location') {
            if (filterKey === 'Location') {
              if (calendar.location?.city || calendar.city) {
                if (!selectedFilters[filterKey].includes(calendar.location?.city) && !selectedFilters[filterKey].includes(calendar.city)) {
                  isFiltered = false;
                  break;
                }
              } else if (calendar.isOnline) {
                if (!selectedFilters[filterKey].includes('Online')) {
                  isFiltered = false;
                  break;
                }
              } else {
                isFiltered = false;
                break;
              }
            } else if (!selectedFilters[filterKey].includes(calendar[lowercaseKey])) {
              isFiltered = false;
              break;
            }
            isFiltered = true;
          }
        }

      }

      return isFiltered;

    }) : calendarsList && calendarsList.data && calendarsList.data.events ? calendarsList.data.events.sort(sortByDate) : null;

    let calendarTiles = filteredCalendars ? filteredCalendars.map((event, i) => {

      const thisEvent = event && event.slug || event.customEventId ? event : isEditor ? {
        title: {
          en: 'Not published event... This is only placeholder for editing.'
        }
      } : '';

      if (!thisEvent) return;

      const elementKey = isEditor ? `EventCalendarTile-${event._id}` : `EventCalendarTile-${event.slug || event.customEventId}-${event._id}`;
      const dateToValue = formatDate(thisEvent.dateFrom, thisEvent.dateTo, thisEvent.timezone, true);
      const eventCity = thisEvent.location ? thisEvent.location.city : thisEvent.city;
      const isOdd = i % 2 === 0;

      return (
        <Wrapper
          {...commonProps}

          key={elementKey}
          typeOfStyle={isOdd ? 'eventCalendarTile' : 'oddCalendarTile'}
          editorData={
            {
              editorType: isOdd ? 'eventCalendarTile' : 'oddCalendarTile',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}

            typeOfStyle={'eventImage'}
            backgroundImage={thisEvent.calendarBackground || thisEvent.eventBackground || thisEvent.metaImage || thisEvent.image || eventBackgroundFallback}
            editorData={
              {
                editorType: 'eventImage',
                ...commonData
              }
            }
          />
          <Wrapper
            {...commonProps}
            typeOfStyle={'eventDetails'}
            editorData={
              {
                editorType: 'eventDetails',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              typeOfStyle={'eventDate'}
              editorData={
                {
                  editorType: 'eventDate',
                  ...commonData
                }
              }
            >
              {`${dateToValue}`}
            </Wrapper>
            <Wrapper
              {...commonProps}

              typeOfStyle={'eventTitle'}
              editorData={
                {
                  editorType: 'eventTitle',
                  ...commonData
                }
              }
            >
              {setLanguageContent(thisEvent, 'title', language)}
            </Wrapper>
            <Wrapper
              {...commonProps}

              typeOfStyle={'eventLocation'}
              editorData={
                {
                  editorType: 'eventLocation',
                  ...commonData
                }
              }
            >
              {`${eventCity ? eventCity : thisEvent.isOnline ? 'Online' : ''}`}
            </Wrapper>


            {
              enableFilters ? (
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'filterTagsList'}
                  editorData={
                    {
                      editorType: 'filterTagsList',
                      ...commonData
                    }
                  }
                >
                  {thisEvent?.tags?.map(tagId => {
                    const fullTag = thisCalendarTags ? thisCalendarTags.find(tag => tag.tagId === tagId) : '';
                    if (fullTag) return (
                      <Wrapper
                        {...commonProps}
                        key={`RedAgendaCalendarTag-${fullTag.tagId}`}
                        typeOfStyle={'filterTagItem'}
                        editorData={
                          {
                            editorType: 'filterTagItem',
                            ...commonData
                          }
                        }
                      >
                        <TagText>
                          {fullTag.title}
                        </TagText>
                      </Wrapper>
                    );
                  })}
                </Wrapper>
              ) : ''
            }



            {/* <Wrapper
              {...commonProps}

              typeOfStyle={'horizontalDivider'}
              editorData={
                {
                  editorType: 'horizontalDivider',
                  ...commonData
                }
              }
            /> */}
            {
              event.customCta ? (
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'eventButton'}
                  href={event.isChapter ? `https://${thisEvent.domain}/${event.useChapterSlug ? 'chapter' : 'location'}/${event.slug}` : `${thisEvent.domain ? `https://${thisEvent.domain}` : thisEvent.website}`}
                  target={'_blank'}
                  editorData={
                    {
                      editorType: 'eventButton',
                      ...commonData
                    }
                  }
                >
                  {event.customCta}
                </Wrapper>
              ) : (
                <Wrapper
                  {...commonProps}
                  type={'text'}
                  typeOfStyle={'eventButton'}
                  href={event.isChapter ? `https://${thisEvent.domain}/${event.useChapterSlug ? 'chapter' : 'location'}/${event.slug}` : `${thisEvent.domain ? `https://${thisEvent.domain}` : thisEvent.website}`}
                  target={'_blank'}
                  textValue={event.customCta}
                  editorData={
                    {
                      editorType: 'eventButton',
                      ...commonData
                    }
                  }
                />
              )
            }
          </Wrapper>
        </Wrapper>
      );
    }) : '';

    if (!calendarsList && isEditor) calendarTiles = (
      <CalendarsPlaceholder>
        <span>
          {'👈 Choose Calendar inside Section settings.'}
        </span>
      </CalendarsPlaceholder>
    );

    return (
      <Wrapper
        {...commonProps}
        key={`Wrapper-${commonData.sectionId}`}
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >

        <Wrapper
          {...commonProps}

          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}

            typeOfStyle={'sectionTitle'}
            defaultValues={defaultTextValues}
            type={'text'}
            editorData={
              {
                editorType: 'sectionTitle',
                ...commonData
              }
            }
          />

          <Wrapper
            {...commonProps}

            typeOfStyle={'paragraph'}
            type={'text'}
            editorData={
              {
                editorType: 'paragraph',
                ...commonData
              }
            }
          />
          <TemplateFilterSwitch
            activeFiltersNumber={activeFiltersNumber}
            handleFilterClick={this.setSelectedFilter}
            availableFilters={availableFilters}
            selectedFilters={selectedFilters}
            enableFilters={enableFilters}
            commonProps={commonProps}
            typeOfStyle={'filterTagItem'}
            customStyles={customStyles}
          />
          <Wrapper
            {...commonProps}

            typeOfStyle={'calendarWrapper'}
            editorData={
              {
                editorType: 'calendarWrapper',
                ...commonData
              }
            }
          >
            {calendarTiles}
          </Wrapper>

        </Wrapper>
      </Wrapper>
    );
  }


}

RedCalendar.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  language: PropTypes.string
};

export default RedCalendar;


